
import React from "react";
import Bio from "./home/Bio";
import Hero from "./home/Hero";
import Quote from "./home/Quote";
import Sponsors from "./home/Sponsors";
import AwardsBand from "./home/AwardsBand";
import SocialBand from "./home/SocialBand";
import TeamsCarousel from "./home/TeamsCarousel";
import GalleryPreview from "./home/GalleryPreview";
import UpcomingMatches from "./home/UpcomingMatches";
import RecentAchievements from "./home/RecentAchievements";
import { ACHIEVEMENTS } from "../data";
import { isPageVisible } from "../helpers";
import { BaseService, IGallery, IProfileWebsite, ITeamHistory, ITournamentEditionMatch, OmneHostService, SanitizedResponse } from "../../../../services";

export interface HomeProps {
    basePath: string;
    publicId: string;
    website: IProfileWebsite;
}

function Home({ website, basePath, publicId }: HomeProps) {

    const omnehostService = OmneHostService.getInstance();
    const [gallery, setGallery] = React.useState<IGallery[]>([]);
    const [matches, setMatches] = React.useState<ITournamentEditionMatch[]>([]);
    const [teamHistories, setTeamHistories] = React.useState<ITeamHistory[]>([]);
    const showAchievements = isPageVisible(website, "ACHIEVEMENTS");
    const achievements = showAchievements ? ACHIEVEMENTS : [];
    const ticker = [
        ...Object.entries((website.home_settings?.show_stats && website.extra_data?.stats) || {}).map(([k, v]) => `${v} ${k.replaceAll("_", " ")}`),
        ...achievements.map((a) => a.title),
        ...teamHistories.map((t) => t.name),
    ];

    React.useEffect(fetchInformation, [website]);

    return (<>
        <Hero website={website} basePath={basePath} ticker={ticker} />
        <AwardsBand achievements={achievements} />
        <Bio website={website} basePath={basePath} teamHistories={teamHistories} />
        {isPageVisible(website, "TEAM_HISTORY") && (<TeamsCarousel website={website} basePath={basePath} teamHistories={teamHistories} />)}
        <RecentAchievements basePath={basePath} achievements={achievements.slice(0, 6)} />
        {(isPageVisible(website, "SCHEDULE") && website.home_settings?.show_schedules !== false) && (<UpcomingMatches website={website} basePath={basePath} publicId={publicId} matches={matches} />)}
        {(isPageVisible(website, "GALLERY") && website.home_settings?.show_top_gallery !== false) && (<GalleryPreview basePath={basePath} gallery={gallery} />)}
        {website.home_settings?.show_sponsors && (<Sponsors sponsors={website.sponsors ?? []} />)}
        {website.member.tagline && (<Quote quote={website.member.tagline} author={website.display_name} />)}
        <SocialBand socials={website.member.social_accounts} />
    </>);

    function fetchInformation() {
        const username = website.member.username;
        if (isPageVisible(website, "GALLERY")) {
            omnehostService.queryMemberGallery(username, {
                size: 10,
                sort: "updated_at,DESC",
            }).then(({ content }: SanitizedResponse<IGallery>) => {
                setGallery(content ?? []);
            }).catch(BaseService.reportError);
        }
        if (isPageVisible(website, "SCHEDULE")) {
            omnehostService.queryMemberSchedule(username, {
                size: 5,
                sort: ["start_date,ASC", "status,ASC"],
            }).then(({ content }: SanitizedResponse<ITournamentEditionMatch>) => {
                setMatches(content ?? []);
            }).catch(BaseService.reportError);
        }
        omnehostService.queryMemberTeamHistory(username, {
            size: 10,
            sort: ["updated_at,ASC", "status,ASC"],
        }).then(({ content }: SanitizedResponse<ITeamHistory>) => {
            setTeamHistories(content ?? []);
        }).catch(BaseService.reportError);
    }
}

export default Home;
